import { Button, Spacer, SvgUsersAdd, Text } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from 'actions/modals';
import { GET_STARTED_CHECKLIST_INVITE_TEAMMATE_CLICKED } from 'constants/events';
import { TEAM_INVITE_MODAL } from 'constants/modalTypes';
import * as analytics from 'utilities/analytics';

const InviteCTA = () => {
  const dispatch = useDispatch();

  return (
    <div>
      <Text>Invite your team to collaborate and share videos more easily.</Text>
      <Spacer bottom="large" />
      <Button
        icon={<SvgUsersAdd />}
        variant="primary"
        onClick={() => {
          analytics.track(GET_STARTED_CHECKLIST_INVITE_TEAMMATE_CLICKED);
          dispatch(openModal(TEAM_INVITE_MODAL));
        }}
      >
        Invite teammates
      </Button>
    </div>
  );
};

export default InviteCTA;
